import { guide1Item, guide1Content } from './guides/guide1';
import { guide3Item, guide3Content } from './guides/guide3';
import { guide2Item, guide2Content } from './guides/guide2';
import { guide4Item, guide4Content } from './guides/guide4';

export interface GuideItem {
  id: string;
  title: string;
  titleEn?: string;
  titleJa?: string;
  titleZhCn?: string;
  titleZhTw?: string;
  image: string;
  imageEn?: string;
  imageJa?: string;
  imageZhCn?: string;
  imageZhTw?: string;
  description: string;
  descriptionEn?: string;
  descriptionJa?: string;
  descriptionZhCn?: string;
  descriptionZhTw?: string;
}

export interface ButtonItem {
  id: string;
  text: string;
  textEn?: string;
  textJa?: string;
  textZhCn?: string;
  textZhTw?: string;
  onClick?: () => void;
}

export interface InlineButton {
  id: string;
  text: string;
  textEn?: string;
  textJa?: string;
  textZhCn?: string;
  textZhTw?: string;
  menuName?: string;
  categoryId?: string;
  franchiseId?: string;
  franchiseName?: string;
  url?: string;
  onClick?: () => void;
}

export interface GuideContent {
  title: string;
  titleEn?: string;
  titleJa?: string;
  titleZhCn?: string;
  titleZhTw?: string;
  subtitle: string;
  subtitleEn?: string;
  subtitleJa?: string;
  subtitleZhCn?: string;
  subtitleZhTw?: string;
  markdownContent: string;
  markdownContentEn?: string;
  markdownContentJa?: string;
  markdownContentZhCn?: string;
  markdownContentZhTw?: string;
  buttons?: ButtonItem[];
  inlineButtons?: InlineButton[];
}

// 한국 음식 가이드 포스팅 목 데이터
export const guideItems: GuideItem[] = [
  guide1Item,
  guide2Item,
  guide3Item,
  guide4Item,
];

// 가이드 컨텐츠 데이터
export const guideContents: Record<string, GuideContent> = {
  "1": guide1Content,
  "2": guide2Content,
  "3": guide3Content,
  "4": guide4Content,
};
